"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _ClipsFilter = _interopRequireDefault(require("composer-lib/data/model/ClipsFilter"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _ClipsFilter.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data,
      type = action.type;

  switch (type) {
    case _ActionTypes.default.CHANGE_CLIPS_AUTHOR:
      return state.set('authorId', data);

    case _ActionTypes.default.CHANGE_CLIPS_SEARCH:
      return state.set('search', data);

    case _ActionTypes.default.CHANGE_CLIPS_TYPE:
      return state.set('type', data);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;